var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDesignation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1673_2347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1673_2347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 13.3333V11.3333H10.0013V10H12.0013V8H13.3346V10H15.3346V11.3333H13.3346V13.3333H12.0013ZM2.0013 14C1.63464 14 1.32075 13.8694 1.05964 13.6083C0.798524 13.3472 0.667969 13.0333 0.667969 12.6667V3.33333C0.667969 2.96667 0.798524 2.65278 1.05964 2.39167C1.32075 2.13056 1.63464 2 2.0013 2H11.3346C11.7013 2 12.0152 2.13056 12.2763 2.39167C12.5374 2.65278 12.668 2.96667 12.668 3.33333V6.66667H11.3346V5.33333H2.0013V12.6667H10.668V14H2.0013ZM2.0013 4H11.3346V3.33333H2.0013V4Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDesignation);
export default __webpack_public_path__ + "static/media/add-designation.a5d5ffb3780eb0ba319daeefd15e0ef4.svg";
export { ForwardRef as ReactComponent };